import axiosIns from "@/libs/axios";

// Governance module API (Director Event Scheduler, Board Calendar, reports).
// Governance working groups reuse the "tools" store with ?governance=1.
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchOptions() {
      return axiosIns.get("governance/options");
    },

    // Events
    fetchEvents(ctx, params = {}) {
      return axiosIns.get("governance/events", { params });
    },
    getEvent(ctx, id) {
      return axiosIns.get(`governance/events/${id}`);
    },
    createEvent(ctx, data) {
      return axiosIns.post("governance/events", data);
    },
    updateEvent(ctx, { id, data }) {
      return axiosIns.post(`governance/events/${id}`, data);
    },
    deleteEvent(ctx, id) {
      return axiosIns.delete(`governance/events/${id}`);
    },
    respond(ctx, { id, response }) {
      return axiosIns.post(`governance/events/${id}/respond`, { response });
    },
    setAttendance(ctx, { id, attendance }) {
      return axiosIns.post(`governance/events/${id}/attendance`, { attendance });
    },
    sendAttendanceEmails(ctx, { id, user_ids = null }) {
      return axiosIns.post(`governance/events/${id}/attendance/send`, user_ids ? { user_ids } : {});
    },
    updateRequirements(ctx, { id, special_needs }) {
      return axiosIns.post(`governance/events/${id}/requirements`, { special_needs });
    },

    // Materials (agenda / minutes / other)
    uploadMaterial(ctx, { id, formData }) {
      return axiosIns.post(`governance/events/${id}/materials`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    deleteMaterial(ctx, materialId) {
      return axiosIns.delete(`governance/materials/${materialId}`);
    },
    downloadMaterial(ctx, materialId) {
      return axiosIns.get(`governance/materials/${materialId}/download`, {
        responseType: "blob",
      });
    },

    // Calendar + dashboard
    fetchCalendar(ctx, params) {
      return axiosIns.get("governance/calendar", { params });
    },
    fetchDashboard() {
      return axiosIns.get("governance/dashboard");
    },

    // Reports
    fetchReportSummary(ctx, params = {}) {
      return axiosIns.get("governance/reports/summary", { params });
    },
    exportEvents(ctx, params = {}) {
      return axiosIns.get("governance/reports/exports/events", {
        params,
        responseType: "blob",
      });
    },
    exportInvitees(ctx, params = {}) {
      return axiosIns.get("governance/reports/exports/invitees", {
        params,
        responseType: "blob",
      });
    },
    fetchReportAnalytics(ctx, params = {}) {
      return axiosIns.get("governance/reports/analytics", { params });
    },
    exportReport(ctx, { report, ...params } = {}) {
      return axiosIns.get(`governance/reports/exports/report/${report}`, {
        params,
        responseType: "blob",
      });
    },
    downloadPdf(ctx, params = {}) {
      return axiosIns.post("governance/reports/pdf", {}, {
        params,
        responseType: "blob",
      });
    },
  },
};
